/* No third-party SDKs: sharing opens only after a reader chooses an action. */
(() => {
  function init(root) {
    if (root.dataset.shareReady) return;
    root.dataset.shareReady = 'true';
    const status = root.querySelector('[data-share-status]');
    const copy = root.querySelector('[data-share-copy]');
    const native = root.querySelector('[data-share-native]');
    const field = root.querySelector('[data-share-url]');
    const manual = () => {
      root.querySelector('[data-share-manual]').open = true;
      status.textContent = root.dataset.fallback;
      field.focus({ preventScroll: true });
      field.select();
    };
    copy.hidden = false;
    copy.addEventListener('click', async () => {
      status.textContent = '';
      try {
        if (!navigator.clipboard?.writeText) return manual();
        await navigator.clipboard.writeText(root.dataset.url);
        status.textContent = root.dataset.copied;
      } catch { manual(); }
    });
    if (typeof navigator.share === 'function') {
      native.hidden = false;
      native.addEventListener('click', async () => {
        status.textContent = '';
        native.disabled = true;
        try {
          await navigator.share({ title: root.dataset.title, url: root.dataset.url });
        } catch (error) {
          if (error.name === 'AbortError') status.textContent = root.dataset.cancelled;
          else manual();
        } finally { native.disabled = false; }
      });
    }
  }
  document.querySelectorAll('[data-guide-share]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-guide-share]').forEach(init));
})();
